import * as React from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { passwordMessage } from './validate';
import * as Util from './util';
import { SyntheticEvent } from 'react';
import { footer } from './widgets/Footer';

import * as ClientHome from './client/Home';
import './css/login.css';
// import  Spinner  from 'react-bootstrap/Spinner';
import { BarLoader } from 'react-spinners';
import { CSSProperties } from 'react';

export interface LoginState {
    focussed: string;
    unknown: boolean;
    email: string;
    password: string;
    resetDone: boolean;
    loading: boolean;
}

export interface LoginProps {
    reset?: boolean;
}

export const frame = (contents: object) => {
    
    return (
        <div className="App" style={{height: '100%', backgroundAttachment: 'fixed', overflow: 'auto'}}>
            <div className="container" style={{height: '100%'}}>
                <br /> <br />
                <div className="row">
                    <div className="col-sm-8 offset-sm-2" style={{backgroundColor: 'white'}}>
                        <h1 className="pt-3 text-center">Axceller @ KorumLegal00</h1>
                        {contents}
                    </div>
                </div>
                {footer('')}
            </div>
        </div>
    );
};

const loginFrame = (body: object) => {
    const testForFun2 = () => {
        window.location.reload();
       };
    return (
            <div className="login-form-main-container-custom">
            <div className="login-header-custom" onClick={() => testForFun2()}>
                <span className="logo-text">Axceller</span>
                <img className="logo-icon" src="favicon.ico" style={{width: '1em', marginLeft: '0.25em', marginRight: '0.25em'}}/>
             </div>
             <hr className="separator"/>
                <div className="login-form-content-custom">
                <div className="login-form-header-custom">
                    <span> WelCome Back!</span>
                </div>
            <div className="login-form-body-custom">
                {body}
            </div>
            </div>
        </div>
        
    );
};

export const toBeImplemented = () => loginFrame(<h5>To be implemented</h5>);

export const registerPanel = () => loginFrame(
    <div className="px-80 py-30">
        <h3>Register</h3>
        <div className="card">
            <div className="card-body text-center">
                <h5>Customer</h5>
                <a href="/#/registerClient" className="btn btn-outline btn-secondary">I would like to register as a customer</a>
            </div>
        </div>
        <div className="card">
            <div className="card-body text-center">
                <h5>Consultant</h5>
                <a href="/#/registerConsultant" className="btn btn-outline btn-secondary">I would like to register as a consultant</a>
            </div>
        </div>
    </div>
);

interface Focussable {
    focussed: string;
}

export class LoginUpdate<A, B extends Focussable> extends React.Component<A, B> {
    assocState(stateKey: string, v: any) {
        const newState = {...(this.state as object), [stateKey]: v} as B;
        this.setState(newState);
    }
    focus(focussed: string) {
        this.setState({...(this.state as object), focussed});
    }
    input(type: string, label: string, stateKey: string, required: boolean) {
        return (
            <div className={this.state.focussed === stateKey || this.state[stateKey] ? 'form-group do-float' : 'form-group'}>
                <input
                    type={type}
                    className="form-control"
                    required={required}
                    value={this.state[stateKey]}
                    onChange={(e: SyntheticEvent<any>) => this.assocState(stateKey, e.currentTarget.value)}
                    id={stateKey}
                    onFocus={(e) => this.focus(stateKey)}
                    onBlur={(e) => this.focus('')}
                />
                <label>{label}</label>
            </div>
        );
    }
    // componentDidMount() {
    //     document.addEventListener('keydown', (e) => 
    //     e.code === 'Enter' && console.log('my function'));
    // }
    email(label: string, stateKey: string) {
        return this.input('email', label, stateKey, true);
    }
    text(label: string, stateKey: string) {
        return this.input('text', label, stateKey, true);
    }
    password(label: string, stateKey: string) {
        return this.input('password', label, stateKey, true);
    }
}

export const override: CSSProperties = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
  };

export class Login12 extends LoginUpdate<LoginProps, LoginState> {
    constructor(props: LoginProps) {
        super(props);
        this.state = {unknown: false, email: '', password: '', resetDone: false, focussed: '', loading: false};
    }
    
    componentDidMount() {
        document.addEventListener('keydown', (e) => 
        e.code === 'Enter' && this.submit());
    }
    async submit() {
        this.setState({...this.state, loading: true});
        // await setTimeout( async () => { await this.setState({...this.state, loading: true});}, 1000);
        const result = await ClientHome.login(this.state);
        if (result.status === 403) {
            // this.setState({...this.state, unknown: true});
            // this.setState({...this.state, loading: false});
            setTimeout(() => this.setState({...this.state, loading: false, unknown: true}), 1000);
        } else if (result.status === 200) {
            const redirect = location.href.split('redirect=')[1];
            if (redirect) {
                location.href = redirect;
                if (!redirect.startsWith(Util.backend as string)) {
                    // setTimeout(() => location.reload(), 100);
                    setTimeout(() => {this.setState({...this.state, loading: false}); location.reload();}, 1000);
                }
            } else {
                
                // this.setState({...this.state, loading: false});
                setTimeout(() => {this.setState({...this.state, loading: false}); location.reload();}, 1000);
            }
        }

    }
    // componentDidMount = () => {
    //     document.addEventListener("keydown", (e) => 
    //       e.code === "Enter" && console.log("my function"))
    //   }
    alertDanger(show: boolean, msg: string) {
        if (show) {
            return (
                <div className="alert alert-danger" style={{ marginTop: '8px'}}>
                    {msg}
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        // const version = () => alert(`Commit: ${commit}`);
        return loginFrame(
            
           <><div className="email-form-wrapper">
                <span className="text-display">Email address</span>
                <div className="email-input-wrapper">
                    <input className="input-display" type="text" disabled={this.state.loading} required={true} value={this.state['email']} onChange={(e: SyntheticEvent<any>) => this.assocState('email', e.currentTarget.value)} id={'email'} onFocus={(e) => this.focus('email')} onBlur={(e) => this.focus('')}/>
                    {/* {this.email('Email', 'email')} */}
                </div>

            </div>
            <div className="password-form-wrapper">
                    <span className="text-display">Password</span>
                    <div className="password-input-wrapper">
                        <input className="input-display" type="password" disabled={this.state.loading} required={true} value={this.state['password']} onChange={(e: SyntheticEvent<any>) => this.assocState('password', e.currentTarget.value)} id={'password'} onFocus={(e) => this.focus('password')} onBlur={(e) => this.focus('')}/>
                        {/* {this.password('Password', 'password')} */}
                    </div>

                </div>
                {this.alertDanger(this.state.unknown, 'Unknown email or password')}
                <div className="forgot-password-form-wrapper">
                    <a className="text-display" href="#/login/reset">Forgot password?</a>
                </div>
                
                <div className="action-btn-form-wrapper">
                    <button className="btn-login" disabled={this.state.loading} onClick={Util.submit(this)}>Login</button>
                </div>
                {/* <Spinner animation="border" size="sm" /> */}
                {/* <ClipLoader color={'#ffffff'} loading={true} cssOverride={override} size={150} speedMultiplier={0.5} /> */}
                <div className="loading-wrapper" style={{ position: 'fixed', bottom: '0px'}}>
                    <BarLoader color={'#95D737'} loading={this.state.loading} cssOverride={override} height={4} width={500} speedMultiplier={0.5} />
                </div>
                
                </>
        );
    }
}

interface ResetState {
    email: string;
    done: boolean;
    focussed: string;
}

export class Reset8 extends LoginUpdate<object, ResetState> {
    constructor(props: object) {
        super(props);
        this.state = {email: '', done: false, focussed: ''};
    }
    async submit() {
        const result = await ClientHome.resetPassword(this.state);
        const done = result.status === 200;
        this.setState({...this.state, done});
    }
    render() {
        return loginFrame(
            this.state.done ? (
                <div className="px-80 py-30">
                    <h4>Please check your email</h4>
                </div>
                ) : (
                <div className="px-80 py-30">
                    <h4>Password recovery</h4>
                    <p><small>We'll send you instructions in email</small></p>
                    <br />

                    <form className="form-type-material" onSubmit={Util.submit(this)}>
                        {this.email('Email', 'email')}
                        <br />
                        <button className="btn btn-bold btn-block btn-primary" type="submit">Reset</button>
                    </form>
                </div>
            )
        );
    }
}

interface Reset2State {
    errors: object;
    name: string;
    password1: string;
    password2: string;
    token: string;
    finished: boolean;
    validToken: boolean;
    focussed: string;
}

interface ResetProps {
    match: {params: {token: string}};
}

interface Params {
    redirect?: string;
    name?: string;
}

export class Reset9 extends LoginUpdate<ResetProps, Reset2State> {
    params: Params = Util.queryString();
    constructor(props: ResetProps) {
        super(props);
        this.state = {
            name: '',
            password1: '',
            password2: '',
            errors: {},
            token: props.match.params.token,
            finished: false,
            validToken: false,
            focussed: '',
        };
    }
    async submit() {
        const result = await ClientHome.resetPassword2(this.state);
        if (result.status === 200) {
            const {redirect} = this.params;
            if (redirect) {
                location.href = redirect;
                setTimeout(() => location.reload(), 100);
            } else {
                location.reload();
            }
        } else {
            this.setState({...this.state, finished: true, validToken: false});
        }
    }
    assocState(k: string, v: any) {
        switch (k) {
            case 'password1':
                Util.customValidity(k, v.length < 5 ? passwordMessage : '');
                break;
            case 'password2':
                Util.customValidity(k, v === this.state.password1 ? '' : 'Passwords must match');
                break;
            default:
        }
        super.assocState(k, v);
    }

    render() {
        return loginFrame(
            !this.state.finished ?
                (
                    <div className="px-80 py-30">
                        <div className="float-right">
                            <img src="Korum_Final_72.png" alt="..." width="200px" />
                        </div>
                        <div className="clearfix" />
                        <h4>Axceller @ KorumLegal44</h4>
                        {location.host.startsWith('st') ? <h1 style={{color: 'red'}}>Staging Site!!!</h1> : null}
                        <br />
                        <form onSubmit={Util.submit(this)} className="form-type-material">
                            <h4>Set Password</h4>
                            {this.params.name ? this.text('Name', 'name') : null}
                            {this.password('Password', 'password1')}
                            {this.password('Repeat Password', 'password2')}
                            <input className="btn btn-bold btn-block btn-primary" type="submit" value="Submit" />
                        </form>
                    </div>
                ) : (
                    this.state.validToken ?
                        <div className="b-3">Password reset.  Please <Link to="/login">Login</Link>.</div>
                        : <div className="b-3">Invalid Token.  Please <Link to="/login/reset">Reset Again</Link>.</div>
                )
        );
    }
}



// WEBPACK FOOTER //
// ./src/LoginUpdate.tsx